export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export interface Article {
  id: string;
  categoryId: string;
  title: string;
  summary: string;
  content: string;
  date: string;
  readCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'news',
    name: '平台资讯',
    icon: 'ri-newspaper-line',
    description: '了解鼎盛平台最新动态、公告通知与行业资讯',
  },
  {
    id: 'guide',
    name: '新手指南',
    icon: 'ri-guide-line',
    description: '从零开始，手把手教您快速上手鼎盛平台',
  },
  {
    id: 'security',
    name: '安全保障',
    icon: 'ri-shield-check-line',
    description: '深入了解平台安全体系与账户保护机制',
  },
  {
    id: 'vip',
    name: '会员权益',
    icon: 'ri-vip-crown-line',
    description: '全面解读VIP会员体系与专属福利政策',
  },
  {
    id: 'events',
    name: '活动专区',
    icon: 'ri-gift-line',
    description: '最新活动资讯、福利领取与限时优惠指南',
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    categoryId: 'news',
    title: '52662鼎盛平台荣获年度最佳服务平台奖',
    summary: '在刚刚结束的2026年度行业评选中，52662鼎盛平台凭借卓越的服务品质和用户口碑，荣获"年度最佳服务平台"称号。',
    content: `<p>在刚刚结束的2026年度行业评选中，<strong>52662鼎盛平台</strong>凭借卓越的服务品质和用户口碑，荣获"年度最佳服务平台"称号。这一荣誉不仅是对平台团队多年努力的肯定，更是数百万用户信赖的见证。</p>
    <p>评选委员会表示，鼎盛平台在<strong>安全性、稳定性、用户体验</strong>等多个维度均表现优异，尤其是在客户服务响应速度和系统稳定性方面，达到了行业领先水平。</p>
    <p>平台负责人表示："这个奖项属于每一位信任和支持我们的用户。未来我们将继续加大技术投入，持续提升服务质量，为所有用户提供更安全、更便捷、更优质的服务体验。"</p>
    <p>此次获奖将进一步巩固52662鼎盛平台在行业中的领先地位，同时也为平台的国际化发展奠定了坚实基础。</p>`,
    date: '2026-07-28',
    readCount: 12850,
    imageSeq: 'article-award-2026',
  },
  {
    id: 'article-2',
    categoryId: 'news',
    title: '鼎盛平台全新版本V5.0正式发布',
    summary: '经过长达半年的精心打磨，52662鼎盛平台V5.0版本正式上线，带来全新UI界面和多项功能升级。',
    content: `<p>经过长达半年的精心打磨，<strong>52662鼎盛平台V5.0版本</strong>正式上线！本次更新带来了全新的用户界面设计，在保持简洁直观的同时，提升了整体视觉体验。</p>
    <p>主要更新内容：</p>
    <ul>
    <li><strong>全新UI设计</strong>：采用现代化设计语言，界面更加美观流畅</li>
    <li><strong>性能优化</strong>：页面加载速度提升40%，操作响应更快</li>
    <li><strong>安全升级</strong>：引入最新加密协议，账户安全更有保障</li>
    <li><strong>新增功能</strong>：智能推荐、个性化定制等多项实用功能</li>
    </ul>
    <p>新版本已全面推送，现有用户登录后将自动提示更新。新用户注册即可体验最新版本的完整功能。</p>`,
    date: '2026-07-20',
    readCount: 23560,
    imageSeq: 'article-v5-launch',
  },
  {
    id: 'article-3',
    categoryId: 'guide',
    title: '新手必读：鼎盛平台注册与使用全攻略',
    summary: '本文为新用户详细介绍鼎盛平台的完整注册流程、基本操作方法和注意事项，助您快速上手。',
    content: `<p>欢迎加入<strong>52662鼎盛平台</strong>！本文将为您详细介绍从注册到熟练使用的完整流程。</p>
    <h4>第一步：注册账号</h4>
    <p>点击官网"立即注册"按钮，输入手机号或邮箱地址，设置安全密码，完成验证后即可创建账号。整个过程仅需1-2分钟。</p>
    <h4>第二步：完善信息</h4>
    <p>登录后建议立即完善个人资料，设置安全问题和绑定备用联系方式，增强账户安全性。</p>
    <h4>第三步：了解平台功能</h4>
    <p>浏览平台各个功能模块，了解服务内容和使用规则。建议先阅读平台公告和常见问题。</p>
    <h4>第四步：享受服务</h4>
    <p>完成以上步骤后，您就可以开始享受鼎盛平台提供的各项优质服务了！别忘记关注平台活动，领取新用户专属福利。</p>`,
    date: '2026-07-15',
    readCount: 56320,
    imageSeq: 'article-beginner-guide',
  },
  {
    id: 'article-4',
    categoryId: 'guide',
    title: '鼎盛平台常见问题解答（FAQ汇总）',
    summary: '整理了用户最常咨询的20个问题，涵盖注册登录、账户安全、会员权益等各个方面。',
    content: `<p>为了帮助广大用户更好地使用<strong>52662鼎盛平台</strong>，我们整理了以下常见问题解答。</p>
    <h4>注册与登录</h4>
    <p><strong>Q：忘记密码怎么办？</strong><br/>A：点击登录页面的"忘记密码"，通过绑定的手机号或邮箱重置密码。</p>
    <p><strong>Q：可以注册多个账号吗？</strong><br/>A：为了保障平台秩序和用户权益，每位用户仅限注册一个账号。</p>
    <h4>账户安全</h4>
    <p><strong>Q：如何提高账户安全性？</strong><br/>A：建议开启双重验证、定期修改密码、不与他人共享账号信息。</p>
    <h4>会员权益</h4>
    <p><strong>Q：如何提升VIP等级？</strong><br/>A：VIP等级根据活跃度和使用时长自动提升，详情请查看会员中心。</p>`,
    date: '2026-07-10',
    readCount: 42180,
    imageSeq: 'article-faq',
  },
  {
    id: 'article-5',
    categoryId: 'security',
    title: '鼎盛平台安全体系深度解析',
    summary: '全面介绍鼎盛平台的多层安全防护体系，包括数据加密、风控系统和隐私保护机制。',
    content: `<p>在<strong>52662鼎盛平台</strong>，用户安全始终是我们的首要任务。本文将深度解析平台的安全防护体系。</p>
    <h4>数据加密技术</h4>
    <p>平台采用银行级SSL/TLS加密协议，所有数据传输均经过高强度加密处理，确保信息在传输过程中不被窃取或篡改。</p>
    <h4>智能风控系统</h4>
    <p>基于大数据和人工智能技术，平台建立了完善的智能风控系统，能够实时监测异常行为并自动触发防护机制。</p>
    <h4>隐私保护</h4>
    <p>严格遵守国家相关法律法规，所有用户隐私数据均经过脱敏处理和安全存储，绝不向第三方泄露。</p>`,
    date: '2026-07-05',
    readCount: 18920,
    imageSeq: 'article-security',
  },
  {
    id: 'article-6',
    categoryId: 'vip',
    title: '鼎盛平台VIP会员权益全面升级',
    summary: '2026年VIP会员体系迎来重大升级，新增多项专属权益，让会员享受更尊贵的服务体验。',
    content: `<p>为回馈广大用户长期以来的支持，<strong>52662鼎盛平台</strong>VIP会员体系于2026年进行全面升级。</p>
    <h4>新增权益亮点</h4>
    <ul>
    <li><strong>专属客服通道</strong>：VIP会员享受优先接入专属客服团队</li>
    <li><strong>月度福利礼包</strong>：每月领取专属福利，越高级别礼包越丰厚</li>
    <li><strong>生日特权</strong>：会员生日当月可获得双倍积分和专属礼品</li>
    <li><strong>优先体验权</strong>：新功能上线前，VIP会员可优先体验</li>
    </ul>
    <p>升级后的VIP体系分为五个等级，每个等级都有对应的专属权益。用户活跃度越高，等级提升越快。</p>`,
    date: '2026-06-28',
    readCount: 31240,
    imageSeq: 'article-vip-upgrade',
  },
  {
    id: 'article-7',
    categoryId: 'events',
    title: '盛夏狂欢季：鼎盛平台周年庆活动重磅来袭',
    summary: '为庆祝平台周年庆典，鼎盛平台推出「盛夏狂欢季」系列活动，多重好礼等你来拿！',
    content: `<p>为庆祝<strong>52662鼎盛平台</strong>周年庆典，平台特别推出「盛夏狂欢季」系列活动，感恩回馈新老用户的支持与厚爱。</p>
    <h4>活动一：新用户专享礼包</h4>
    <p>活动期间新注册用户可领取价值千元的专属礼包，包含多重福利和优惠权益。</p>
    <h4>活动二：邀请好友得奖励</h4>
    <p>每成功邀请一位好友注册，双方均可获得丰厚奖励，邀请越多奖励越多。</p>
    <h4>活动三：每日签到抽奖</h4>
    <p>活动期间每日签到即可参与幸运抽奖，奖品丰富，中奖率超高。</p>
    <p>活动时间：2026年7月1日至8月31日。详情请关注平台公告或咨询在线客服。</p>`,
    date: '2026-07-01',
    readCount: 67540,
    imageSeq: 'article-summer-event',
  },
  {
    id: 'article-8',
    categoryId: 'events',
    title: '鼎盛平台感恩回馈：老用户专属福利发放中',
    summary: '为感谢老用户一直以来的陪伴，平台特别推出老用户感恩回馈活动，专属福利限时领取。',
    content: `<p>一路同行，感恩有您。<strong>52662鼎盛平台</strong>特别推出老用户感恩回馈活动，为长期支持平台的忠实用户送上专属福利。</p>
    <p>活动面向注册时长超过一年的用户，根据使用年限和活跃度自动匹配福利等级。福利内容包括专属优惠权益、积分翻倍、限量周边礼品等。</p>
    <p>符合条件的用户登录后可在个人中心查看并领取专属福利。活动截止日期为2026年8月15日，请尽早领取以免错过。</p>`,
    date: '2026-06-20',
    readCount: 45230,
    imageSeq: 'article-loyalty-reward',
  },
];